<template>
  <div class="login-container">
    <a-row>
      <a-col :xs="0" :md="0" :sm="12" :lg="14" :xl="16"></a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="10" :xl="6">
        <div class="login-container-form">
          <div class="login-container-hello">您好!</div>
          <div class="login-container-title">欢迎进入正博跨境供应链平台</div>
          <a-form ref="formRef" :model="loginForm">
            <a-form-item name="username" :rules="[{ required: true, message: '请输入账号' }]">
              <a-input v-model:value="loginForm.username" autocomplete="off" placeholder="请输入账号">
                <template v-slot:prefix>
                  <UserOutlined style="color: rgba(0, 0, 0, 0.25)" />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item name="password" :rules="[{ required: true, message: '请输入密码' }]">
              <a-input-password v-model:value="loginForm.password" autocomplete="off" placeholder="请输入密码">
                <template v-slot:prefix>
                  <LockOutlined style="color: rgba(0, 0, 0, 0.25)" />
                </template>
              </a-input-password>
            </a-form-item>
            <a-form-item name="verifycode" :rules="[{ required: true, message: '验证码不能为空' }]">
              <a-input-group compact>
                <a-input v-model:value="loginForm.verifycode" placeholder="验证码" :disabled="logining" style="width:63%"
                  @keyup.enter="doLogin">
                  <template #prefix>
                    <KeyOutlined />
                  </template>
                </a-input>
                <div style="width:37%">
                  <div v-if="verifying" style="width:100%;height:44px">
                    <img :src="loading_image"
                      style="width:100%;height:44px;cursor:pointer;background:#eee;object-fit: contain;" />
                  </div>
                  <img v-else-if="verifyImage" :src="verifyImage"
                    style="width:100%;height:44px;cursor:pointer;background:#eee;object-fit: contain;"
                    @click="getVerifyCode" />
                </div>
              </a-input-group>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="doLogin" :loading="logining">
                登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </a-col>
    </a-row>
    <div class="login-container-tips">
      Copyright {{ $filters.dateFormat(new Date(), 'YYYY') }} 河南正博电子商务有限公司. All rights reserved.
    </div>
  </div>
</template>
<script setup>
import { UserOutlined, LockOutlined, KeyOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, toRaw, } from "vue";
import { useRoute, useRouter } from "vue-router";
import _ from "underscore";
import loading_image from '../assets/loading.gif';

const { proxy } = getCurrentInstance();
const route = useRoute();
const router = useRouter();

const loginForm = ref({});
const verifying = ref(false);
const verifyImage = ref("");
const logining = ref(false);

onMounted(() => {
  loginForm.value = initForm();;
});
onActivated(() => {
  getVerifyCode();
});
const initForm = () => ({
  type: "sc",
  username: "",
  password: "",
  verifycode: "",
  verifyuuid: "",
});
const getVerifyCode = () => {
  verifying.value = true;
  proxy.$api.doAPI("/authcode").then((res) => {
    verifying.value = false;
    if (res.code === 0) {
      loginForm.value = {
        ...toRaw(loginForm.value),
        verifyuuid: res.data.uuid,
      }
      verifyImage.value = res.data.img;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    verifying.value = false;
    console.error(err);
  });
};
const doLogin = () => {
  logining.value = true;
  proxy.$api.doAPI("/login", { dataForm: loginForm.value, ...route.query }).then((res) => {
    logining.value = false;
    if (res.code === 0) {
      localStorage.setItem("zbsc_admin.token", res.data.token);
      proxy.$utils.setStore(res.data);
      router.replace({ path: "/" }).catch(console.error);
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    logining.value = false;
    console.error(err);
  });
};
</script>
<style lang="less" scoped>
:deep(.ant-card-head-title) {
  text-align: center;
  font-size: 30px;
}

:deep(.ant-form-item-control-input-content) {
  display: flex;
  justify-content: space-between;
}

:deep(.ant-spin-nested-loading) {
  width: 26%;
}

.login-container {
  width: 100%;
  height: 100vh;
  background: url('~@/assets/login_bg.png');
  background-size: cover;
  overflow: hidden;

  .login-container-form {
    width: calc(100% - 40px);
    height: 430px;
    padding: 4vh;
    margin-top: calc((100vh - 380px) / 2);
    margin-right: 20px;
    margin-left: 20px;
    background: url('~@/assets/form_bg.png');
    background-size: 100% 100%;
    border-radius: 10px;
    box-shadow: 0 2px 8px 0 rgba(7, 17, 27, 0.06);

    .login-container-hello {
      font-size: 32px;
      color: #fff;
    }

    .login-container-title {
      margin-bottom: 30px;
      font-size: 20px;
      color: #fff;
    }

    .ant-col {
      width: 100%;
      padding: 0 10px 0 10px;
    }

    :deep(.ant-input) {
      height: 35px;
    }

    .ant-btn {
      width: 100%;
      height: 45px;
      border-radius: 99px;
    }

    .ant-form-item-explain-error {
      color: #faad14;
    }

    .ant-form-item-has-error {
      border-color: #faad14;
    }
  }

  .login-container-tips {
    position: fixed;
    bottom: 10px;
    width: 100%;
    height: 40px;
    color: rgba(255, 255, 255, 0.856);
    text-align: center;
  }
}
</style>
